module.exports = __webpack_public_path__ + "static/media/penguin-run.e5659483.png";